import React from 'react';
import pdfLogo from '../assets/Generate PDF logo.png';

function GeneratePDFButton() {
  return (
    <button type="submit" className="generate-btn">
      <img src={pdfLogo} alt="Generate PDF"/>
    </button>
  );
}

export default GeneratePDFButton;
